import { Link, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1 w-full flex items-center justify-center px-4 py-16">
        <div className="text-center max-w-lg">
          <p className="font-heading text-7xl md:text-9xl font-black text-primary-100 select-none">
            404
          </p>
          <h1 className="font-heading text-2xl md:text-3xl font-black text-foreground-950 mt-4 mb-3">
            页面走丢了
          </h1>
          <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-2">
            你访问的页面不存在或已被移除。
          </p>
          <p className="text-xs text-foreground-400 font-mono mb-8 break-all">
            {location.pathname}
          </p>
          <div className="flex items-center justify-center gap-3 flex-wrap">
            <Link
              to="/"
              className="px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              返回首页
            </Link>
            <Link
              to="/category/film-news"
              className="px-5 py-2.5 rounded-full border border-background-300 text-foreground-700 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              浏览影视资讯
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}